<template>
  <div class="container">
    <div v-for="(list, index) in elements" :key="index" class="orbit">
      <div class="border" :style="styleBorder(index)" />
      <div v-for="(e, i) in elements[index]"
          class="element" 
          :style="styleElement(index, i)" 
          :key="i" >
        <img :src="e.img_url" />
      </div>
    </div>
    <div class="elementMe">
      Me
    </div>
  </div>
</template>

<script>
export default {
  name: 'Orbit',
  props: {
    elements: Object
  },
  data () {
    return {
      frame: 0
    }
  },
  mounted () {
    setInterval(() => {
      this.frame = this.frame += 0.05
      if (this.frame > 1e+300) {
        this.frame = 0
      }
    }, 100)
  },
  methods: {
    styleOrbit() {
      return {
        
      }
    },
    styleBorder (i) {
      const radius = 900 + 400 * i/10
      const elementRadius = 35 + 9 * i/10

      return {
        width: Math.ceil(radius - elementRadius) + 'px',
        height: Math.ceil(radius - elementRadius) + 'px',
        transform: 'translate(-50%,-50%)'
      }
    },
    styleElement (i, index) {
      const radius = 900 + 400 * i/10
      const elementRadius = 35 + 9 * i/10

      let divCenterX = Math.ceil((radius - elementRadius) / 2)
      let divCenterY = Math.ceil((radius - elementRadius) / 2)
      let angle = index * 2 * Math.PI / this.elements[i].length + this.frame/((i/10)+1)
      const x = Math.cos(angle)*divCenterX - elementRadius
      const y = Math.sin(angle)*divCenterY - elementRadius
      
      return {
        top: y + 'px',
        left: x + 'px',
        width: elementRadius*2 + 'px',
        height: elementRadius*2 + 'px',
        padding: 5 + i/10 + 'px',
        'background-color': this.elements[i][index].color
      }
    }
  }
}
</script>

<style scoped>
@keyframes rotate {
  from {transform: rotate(0deg);}
  to {transform: rotate(360deg);}
}
@keyframes counterRotate {
  from {transform: rotate(0deg);}
  to {transform: rotate(-360deg);}
}
.container {
  top: 50%;
  left: 50%;
  position: absolute;
  animation-name: rotate;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-duration: '300s'
}
.orbit {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.border {
  position: fixed;
  top: 50%;
  left: 50%;
  border-color: rgb(1, 1, 94);
  border-style: dashed;
  border-width: 2px;
  border-radius: 100%;
}
.elementMe {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  background-color: rgb(91, 91, 255);
  color: white;
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  font-size: 110px;
  transform: translate(-50%,-50%);

  width: 400px;
  height: 400px;
  padding: 5px;
  box-sizing: border-box;
  border-radius: 100%;
}
.element {
  display: flex;
  justify-content: center;
  align-items: center;

  position: fixed;
  box-sizing: border-box;
  border-radius: 100%;
}
.element img {
  width: 100%;
  height: 100%;
  background-color: white;
  border-radius: 100%;
}
</style>
